import { gsap } from 'gsap';
import { connect } from 'react-redux';
import { SplitText } from 'gsap/SplitText';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState, useRef } from 'react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Link, withRouter } from 'react-router-dom';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

import logo from '../../static/img/logo.png';
import { forgotPassword } from '../../store/Auth';
import { getBranding } from '../../store/Settings';
import forgotPasswordImg from '../../static/img/forgot-password.png';
gsap.registerPlugin(SplitText, ScrollTrigger);
const ForgotPassword = ({ history }) => {
  const dispatch = useDispatch();
  const { currentBranding } = useSelector(state => state['Settings']);
  const headingRefs = useRef([]);
  const paragraphRefs = useRef([]);
  const splitParagraphs = useRef([]);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false)

  useEffect(() => { document.title = 'Forgot Password | ' + (currentBranding?.['agencyName']) }, [currentBranding]);

  const handleLogin = () => {
    setLoading(true)
    dispatch(forgotPassword({
      formData: { email }, successCallback: () => {
        setLoading(false)
        history.push('/reset-password')
      }, failCallback: () => setLoading(false)
    }))
  }

  useEffect(() => {
    // Reset any previous SplitText instances
    splitParagraphs.current.forEach((split) => split?.revert?.());
    splitParagraphs.current = [];

    // Animate each heading
    headingRefs.current.forEach((el, i) => {
      gsap.fromTo(
        el,
        { opacity: 0, filter: "blur(10px)", y: -20 },
        {
          opacity: 1,
          filter: "blur(0px)",
          y: 0,
          duration: 0.8,
          ease: "power3.out",
          delay: i * 0.3,
        }
      );
    });

    // Animate each paragraph with SplitText
    paragraphRefs.current.forEach((el, i) => {
      const split = new SplitText(el, { type: "chars" });
      splitParagraphs.current.push(split);

      gsap.fromTo(
        split.chars,
        { opacity: 0, y: 20 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          stagger: 0.02,
          ease: "power2.out",
          delay: (headingRefs.current.length + i) * 0.1,
        }
      );
    });
  }, []);


  return (
    <div className='login-page'>
      <div className='logo-area'>
        { currentBranding?.['logo'] && <img className='login-page-logo' src={currentBranding?.['logo']} alt={currentBranding?.['agencyName']} /> }
      </div>
      <div className='auto-container'>
        <div className='row'>
          <div className='col-lg-6 col-md-6 col-sm-12 login-area'>
            <div className='left-img-area forgot-password-img'>
              <img src={forgotPasswordImg} alt='' />
              <h2 ref={(el) => el && headingRefs.current.push(el)}>{currentBranding?.['agencyName']}</h2>
              <p ref={(el) => el && paragraphRefs.current.push(el)}>Access predictive AI insights, automated follow-ups<br />and always-on AI assistance.</p>
            </div>
          </div>
          <div className='col-lg-6 col-md-6 col-sm-12 login-area'>
            <div className='login-form'>
              <div className='title-area'>
                <h2 ref={(el) => el && headingRefs.current.push(el)}>Reset Your Password</h2>
                <p ref={(el) => el && paragraphRefs.current.push(el)}>Enter your email address and we'll send you a link to reset<br />your password.</p>
              </div>
              <ValidatorForm className='validator-form mt-4' onSubmit={handleLogin}>
                <div className='group-form'>
                  <label>Email</label>
                  <TextValidator
                    type='text'
                    name='email'
                    value={email}
                    margin='dense'
                    variant='outlined'
                    placeholder='Please enter your email here'
                    className='login-input-fields'
                    validators={['required', 'isEmail']}
                    onChange={(e) => setEmail(e.target.value)}
                    errorMessages={['Email can not be empty', 'Email is not valid']}
                  />
                </div>
                <div className='group-form text-center'>
                  <button type='submit' className='btn-style-new' disabled={loading}>
                    {!loading ? 'Send Code' : <div><i className='fa fa-spinner fa-spin'></i></div>}
                  </button>
                </div>
                <div className='group-form checkbox-group'>
                  <Link className='forget-pass' to='/login'>Login ?</Link>
                </div>
              </ValidatorForm>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default (withRouter(ForgotPassword))